import {request, uploadPath} from "../axios/index";

let coupon = {
	getScenicArea(data = {}) {
		return request({
			url: 'admin/getScenicArea',
			method: 'post',
			data
		})
	},
	getCouponPackageList(data = {}) {
		return request({
			url: 'admin/getCouponPackageList',
			method: 'post',
			data
		})
	},
	addCouponPackage(data = {}) {
		return request({
			url: 'admin/addCouponPackage',
			method: 'post',
			data
		})
	},
	deleteCouponPackage(data = {}) {
		return request({
			url: 'admin/deleteCouponPackage',
			method: 'post',
			data
		})
	},
	updateCouponPackage(data = {}) {
		return request({
			url: 'admin/updateCouponPackage',
			method: 'post',
			data
		})
	},
	getCouponList(data) {
		return request({
			url: 'admin/getCouponList',
			method: 'post',
			data
		})
	},
	addCoupon(data) {
		return request({
			url: 'admin/addCoupon',
			method: 'post',
			data
		})
	},
	deleteCoupon(data) {
		return request({
			url: 'admin/deleteCoupon',
			method: 'post',
			data
		})
	},
	updateCouponPackageStatus(data) {//券包上下架
		return request({
			url: 'admin/updateCouponPackageStatus',
			method: 'post',
			data
		})
	},
	addCouponShop(data) {//新增店铺
		return request({
			url: 'admin/addCouponShop',
			method: 'post',
			data
		})
	},
	updateCouponShop(data) {//修改店铺
		return request({
			url: 'admin/updateCouponShop',
			method: 'post',
			data
		})
	},
	deleteCouponShop(id) {//删除店铺
		return request({
			url: 'admin/deleteCouponShop',
			method: 'post',
			data: {id}
		})
	},
	getCouponShopList(data) {//查询店铺列表
		return request({
			url: 'admin/getCouponShopList',
			method: 'post',
			data
		})
	},
	getCouponShopEmpList(data) {//查询店员列表
		return request({
			url: 'admin/getCouponShopEmpList',
			method: 'post',
			data
		})
	},
	addCouponShopEmp(data) {//添加店员
		return request({
			url: 'admin/addCouponShopEmp',
			method: 'post',
			data
		})
	},
	updateCouponShopEmp(data) {//修改店员
		return request({
			url: 'admin/updateCouponShopEmp',
			method: 'post',
			data
		})
	},
	deleteCouponShopEmp(id) {//删除店员
		return request({
			url: 'admin/deleteCouponShopEmp',
			method: 'post',
			data:{id}
		})
	},
	getAreaCountData(data) {//统计景区数据
		return request({
			url: 'admin/getAreaCountData',
			method: 'post',
			data
		})
	},
	upImg(data) {//富文本图片上传
		return request({
			url: uploadPath,
			method: 'post',
			data
		})
	},
}

export default coupon




// WEBPACK FOOTER //
// ./src/api/coupons.js